export const formatReasoningEffort = (effort: string): string => effort.charAt(0).toUpperCase() + effort.slice(1);
